<template>
  <div :id="uuid" :style="{width:width+'px',height:height+'px'}"/>
</template>

<script setup>
//基础K线图
import {getDataJson, pollingRefresh,hasNonEmptyValues,hasProperty } from "@/utils/refresh-cpt-data";
import {onMounted, watch, computed} from "vue";
import * as echarts from 'echarts'

const props = defineProps({
  width:Number,
  height:Number,
  option:Object,
  show:Boolean,
  components:Array,
  current: Object
})
// 新增属性兼容旧代码
const attr = props.option.attribute
if (!attr.globalDataReload) attr.globalDataReload = [0]

let dataReload = computed(() => props.option.attribute.globalDataReload || [0])
watch(() => props.current.cptShow,(val)=>{
    if (val && dataReload.value.includes(1)) {
      refreshCptData();
    }
  })
  watch(() => props.option.attribute.hideCompInTabw,(val)=>{
    if (!val && dataReload.value.includes(1)) {
      refreshCptData();
    }
  })
watch(() => props.option.attribute, (obj) => {
  if(obj.dataZoom && obj.dataZoom.show) {
    obj.grid.y2 = obj.grid.y2 == 30 ? 50 : obj.grid.y2;
  } else {
    obj.grid.y2 = obj.grid.y2 == 50 && obj.grid.y2 != 30 ? 30 : obj.grid.y2;
  }
  processData(props.option.cptDataForm,newData,jsFunFlag)
  loadChart(obj);
},{deep:true})
watch(() => [props.width,props.height], () => {
  chart.resize()
})
let uuid = require('uuid').v1();
let chartOption = {};
let chart = null
let cptData = [];
let newData = "";
let jsFunFlag = false;
const emit = defineEmits(['clickHandler'])

onMounted(()=>{
  chart = echarts.init(document.getElementById(uuid))
  if (dataReload.value.includes(0)) {
    refreshCptData();
  }
})

function refreshCptData(cptDataForm = props.option.cptDataForm,paras) {
  pollingRefresh(uuid, cptDataForm, () => loadData(cptDataForm,paras),
  props.components)
}
function loadData(cptDataForm,paras){
  getDataJson(cptDataForm,paras,(res)=> {
        // cptData = res;
        newData = cptDataForm.dataSource == '4' && hasProperty(res,'jsFunction') ? res.resStr : res;//相同数据集只调用一次接口原因
        jsFunFlag = cptDataForm.dataSource == '4' && hasProperty(res,'jsFunction') ? res.jsFunction : false;//相同数据集只调用一次接口原因
        processData(cptDataForm,newData,jsFunFlag)
        loadChart(props.option.attribute);

      })
}
function processData(cptDataForm,res,jsFunFlag){
  console.log(res,'r')
          // 第一层判断 如果选择数据集
          if(cptDataForm.dataSource == '4') {
            // 第二层判断 ，如果没有配转换脚本
            if(jsFunFlag) { // 没有全部配置映射字段
                if(hasNonEmptyValues(props.option.attribute.cptTableData)) {
                    const dataKey = props.option.attribute.cptTableData;
                      // const { group: groupNameKey, name: dataNameKey, value: valueKey } = dataKey.reduce(
                      //     (acc, cur) => ({ ...acc, [cur.namekey]: cur.value }),
                      //   {});
                      // let newarr = res.reduce((accumulator, current) => {
                      //   let groupName = current[groupNameKey];
                      //   let dataName = current[dataNameKey];
                      //   let values = parseSLValues(current[valueKey]);

                      //   let existingGroup = accumulator.find(g => g.group === groupName);

                      //   if (!existingGroup) {
                      //     existingGroup = { group: groupName, data: [] };
                      //     accumulator.push(existingGroup);
                      //   }

                      //   existingGroup.data.push({ name: dataName, value: values });

                      //   return accumulator;
                      // }, []);
                      const { group: groupNameKey, name: dataNameKey, value: valueKey, type: typeKey } = dataKey.reduce(
  (acc, cur) => ({ ...acc, [cur.namekey]: cur.value }),
  {}
);

let newarr = res.reduce((accumulator, current) => {
  let groupName = current[groupNameKey];
  let dataName = current[dataNameKey];
  let values;
  
  if (current[typeKey] && current[typeKey] === 'line') {
    values = String(current[valueKey]);
  } else {
    values = parseSLValues(current[valueKey]);
  }
   // 查找或创建包含group和可能的type的项（仅在type已定义且不为null时）
  let existingGroup = accumulator.find(g => g.group === groupName);
  let groupType = current[typeKey];

  if (!existingGroup) {
    let groupToAdd = { group: groupName, data: [] };
    if (typeof groupType !== 'undefined' && groupType !== null) {
      groupToAdd.type = groupType;
    }
    accumulator.push(groupToAdd);
    existingGroup = groupToAdd;
  } else if (typeof groupType !== 'undefined' && groupType !== null) {
    // 如果已存在的组没有type信息，并且当前记录的type已定义且不为null，则添加type信息
    existingGroup.type = groupType;
  }

  let newDataItem = { name: dataName, value: values };

  existingGroup.data.push(newDataItem);

  return accumulator;
 
}, []);
                  
                        console.log(newarr,'新数组')
                        cptData = newarr; 
              }
             } else { // 如果配置了转换脚本
                cptData = res;
             }
          } else { // 不是数据集类型，是静态数据
               cptData = res;
          } 
  }
  function parseSLValues(slValue) {
    return slValue.includes(',')
    ? slValue.split(',').map(Number)
    : null; // 假设parseSLValues函数用于解析逗号分隔的数值数组
  // return slString.split(',').map(Number);
}

function loadChart(attr) {
  let xAxisData = [];
  cptData[0].data.forEach(item => {
    xAxisData.push(item.name)
  })
  let xAxis = JSON.parse(JSON.stringify(attr.xAxis))
  xAxis.data = xAxisData
  chartOption = {
    title:attr.title,
    xAxis: xAxis,
    yAxis: attr.yAxis,
    legend: attr.legend,
    grid:Object.assign(attr.grid,{containLabel: true}),
    tooltip: attr.tooltip,
    dataZoom:attr.dataZoom,
  }
  chartOption.series = [];
  for (let i = 0; i < cptData.length; i++) {
    const item = cptData[i]
    let data = []
    item.data.forEach(column => {
      data[xAxisData.indexOf(column.name)] = column.value
    })
    if(item.type){
      chartOption.series.push({
        name: item.group,
        type: 'line',
        data: data,
        smooth: true,
        symbolSize:0,
        z:0,
        itemStyle:{
          color:attr.color[i],
        }
      })
    }else{
      chartOption.series.push({
        name: item.group,
        type: 'candlestick',
        data: data
      })
    }
  }
  chart.setOption(chartOption);
  chart.on('click', (params) => {
    emit("clickHandler",props.option.interaction,'default',params.name)
  })
}

defineExpose({refreshCptData})
</script>

<style scoped>

</style>
